export const COMPONENT_NAME = 'Player.ConcurrencyModal';
export const CONCURRENCY_ICON_PATH = 'play-icon';
